// Import of the module

import { parseDate } from "@/lib/utils";
import { ColumnDef } from "@tanstack/react-table";

// Type of the fields in the table

export type AhoyEvent = {
  id: number;
  visit_id?: number;
  user_id?: number;
  name: string;
  properties: Record<string, any>;
  time: string;

  // joined/derived fields
  user?: {
    id: number;
    email?: string;
  } | null;
  user_email?: string | null;
  visit?: {
    id: number;
    ip?: string;
    browser?: string;
    started_at?: string;
  } | null;
};

// Definition of the columns

export const ahoy_events_columns: ColumnDef<AhoyEvent>[] = [
  {
    accessorKey: "id",
    header: "Id",
  },
  {
    accessorKey: "user_email",
    header: "User Email",
    cell: ({ row }) => {
      const user = row.original.user;
      const email =
        user?.email ||
        row.original.properties?.user?.email ||
        row.original.user_email;
      return email || "";
    },
  },
  {
    accessorKey: "name",
    header: "Name",
    cell: ({ row }) => {
      const name = row.original.name;
      if (name === "custom_failure#respond") {
        const controller = row.original.properties?.controller || "";
        const action = row.original.properties?.action || "";
        return `${controller}#${action} (${name})`;
      }
      return name;
    },
  },
  {
    accessorKey: "time",
    header: "Time",
    cell: ({ row }) => {
      return parseDate(row.getValue("time"));
    },
  },
  {
    accessorKey: "visit_id",
    header: "Visit",
    cell: ({ row }) => {
      const visitId = row.getValue("visit_id") as number;
      return visitId || "";
    },
  },
  {
    accessorKey: "visit.ip",
    header: "Visit Ip",
    cell: ({ row }) => {
      const visit = row.original.visit;
      return visit?.ip || "";
    },
  },
  {
    accessorKey: "visit.browser",
    header: "Visit Browser",
    cell: ({ row }) => {
      const visit = row.original.visit;
      return visit?.browser || "";
    },
  },
  {
    accessorKey: "visit.started_at",
    header: "Visit Started At",
    cell: ({ row }) => {
      const visit = row.original.visit;
      return visit?.started_at ? parseDate(visit.started_at) : "";
    },
  },
];
